/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';
import { ActionLinkColumn } from '@veeam-vspc/shared/components';
import { isPositiveNumber } from '@veeam-vspc/shared/helpers';
import { ColumnTexts } from '@veeam-vspc/shared/enums';

import { RestorePointDialog } from './components/RestorePointDialog';

import type { RestorePointDialogProps } from './components/RestorePointDialog';

export interface RestorePointColumnProps extends Omit<RestorePointDialogProps, 'deactivate'> {
    value: string | number | null;
}

export const RestorePointColumn: React.FC<RestorePointColumnProps> = ({ value, ...restProps }) => (
    <ActionLinkColumn
        content={isPositiveNumber(value) ? value : ColumnTexts.DashSymbol}
        isLink={isPositiveNumber(value)}
        isExtMode={true}
        renderModal={({ deactivate }) => (
            <RestorePointDialog
                {...restProps}
                deactivate={deactivate}
            />
        )}
    />
);

